import { type ReactNode, useState } from 'react';
import type { Creator } from '@/types';
import { CreatorDetailModal } from '@/modules/creators';
import { RecentCreatorsTable } from './recent-creators-table';

export function RecentSection({
  creators,
}: {
  creators: Creator[];
}): ReactNode {
  const [selected, setSelected] = useState<string | null>(null);
  if (!creators.length) return null;
  return (
    <div>
      <p className="mb-sm text-[11px] font-medium uppercase tracking-wider text-text-tertiary/50">
        Recientes
      </p>
      <RecentCreatorsTable creators={creators} onSelect={setSelected} />
      <CreatorDetailModal leadId={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
